module.exports = __webpack_public_path__ + "0a1c24c621c8be9c06eab532dc34202d.woff2";